import { MAX_WIDTH_MESSAGE_DESKTOP, MAX_WIDTH_MESSAGE_MOBILE } from '../message-wrapper';

export const MAX_WIDTH_IMAGE_DESKTOP = MAX_WIDTH_MESSAGE_DESKTOP;
export const MAX_HEIGHT_IMAGE_DESKTOP = 400;

export const MAX_WIDTH_IMAGE_MOBILE = MAX_WIDTH_MESSAGE_MOBILE;
export const MAX_HEIGHT_IMAGE_MOBILE = 280;
